import React from 'react';
import { Banner } from '@fortress-technology-solutions/fortress-component-library/Atoms';
import useIntl from '../../hooks/useIntl';
import { useBlueMoonActivePropertiesNote } from './hooks';
import messages from './messages';

type Props = {
  organizationId: ?string,
  properties: Array<{ id: string, name: string }>,
  propertiesError?: boolean,
  propertiesLoading?: boolean,
};

const BlueMoonActivePropertiesNote = ({
  organizationId,
  properties,
  propertiesError = false,
  propertiesLoading = false,
}: Props) => {
  const { formatMessage } = useIntl();
  const { isVisible, isForbidden, isError, isLoading, hasActiveProperties } =
    useBlueMoonActivePropertiesNote({
      organizationId,
      properties,
      propertiesError,
      propertiesLoading,
    });

  if (!isVisible) return null;

  // The route needs organization-wide lease-read. A refusal is neither an outage nor "off".
  if (isForbidden) {
    return (
      <Banner
        status="info"
        message={formatMessage(messages.forbidden)}
        sx={{ mb: 2 }}
      />
    );
  }

  if (isError) {
    return (
      <Banner
        status="warning"
        message={formatMessage(messages.unavailable)}
        sx={{ mb: 2 }}
      />
    );
  }

  // A pending read is unknown, never "no Blue Moon properties".
  if (isLoading) {
    return (
      <Banner
        status="info"
        message={formatMessage(messages.loading)}
        sx={{ mb: 2 }}
      />
    );
  }

  if (!hasActiveProperties) return null;

  return (
    <Banner
      status="info"
      title={formatMessage(messages.active)}
      message={formatMessage(messages.fallback)}
      sx={{ mb: 2 }}
    />
  );
};

export default BlueMoonActivePropertiesNote;
